import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import  { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import AnnouncementBanner from "./AnnoucementBanner";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";






export default class AnnouncementBar extends WBComponent {

    


    constructor(){
        super();
        this.typename =wBComponentTypeNames.announcementBar;
        this.displayName = "Announcement Bar";
        this.dropList = [];
        this.editList =  ["announcementExpiresAt","announcementToggle","announcementText","annoucementlink","textStyle","annoucementBg","annoucementTxtClr",componentAttributeTypes.multiLocation];
        this.primaryEditAttributes= ["announcementToggle","announcementText","annoucementlink","textStyle","annoucementBg","annoucementTxtClr"];
        this.contentEditable = false;
        this.hideAdvancedSettings = true;
    
        
    }


    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {

        const announcementToggle = new AttributeDefinition("announcementToggle","Enable Announcement Bar","",AttributeInputType.ButtonField,[{label:"Off",value:""},{label:"On",value:"true"}]);
        const annoucementText = new AttributeDefinition("announcementText","Text","",AttributeInputType.EmojiField);
        annoucementText.placeHolder= "Type Message"

        const link = new AttributeDefinition("annoucementlink","Clickthrough Link","",AttributeInputType.LinkField);
        const bg = new AttributeDefinition("annoucementBg","Background Color","",AttributeInputType.ColorField);
        const txt = new AttributeDefinition("annoucementTxtClr","Text Color","",AttributeInputType.ColorField);

        return [announcementToggle,annoucementText,link,bg,txt];
    
    }

    RenderLayout({component,children,screenSize,isEditor,userContext}:WBRenderProps)
     {

        return (


            <AnnouncementBanner atts={component} isEditor={isEditor} inId="ann" pageData={userContext.pages as any}/>
        )

    }

}